import { render, staticRenderFns } from "./TranslateDetected.vue?vue&type=template&id=28532fd4&scoped=true"
import script from "./TranslateDetected.vue?vue&type=script&lang=js"
export * from "./TranslateDetected.vue?vue&type=script&lang=js"
import style0 from "./TranslateDetected.vue?vue&type=style&index=0&id=28532fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28532fd4",
  null
  
)

export default component.exports